import PropTypes from 'prop-types'
import { cn } from '../../_utils/cn'
import { menuVariants } from '../variants/Menu.variants'

/**
 * Contenedor de la barra horizontal de Nivel 1.
 * @param {Object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export const MenuBar = ({ className, children }) => {
  return (
    <nav aria-label="Menú principal" className={cn(menuVariants.bar(), className)}>
      {children}
    </nav>
  )
}

MenuBar.displayName = 'MenuBar'

MenuBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}
